export default class DownloadFile {
	static _arrayBufferToBlob(arrayBuffer, type) {
		return new Blob([arrayBuffer], {type: type})
	}

	static downloadArrayBufferPdf(arrayBuffer, name) {
		const blob = this._arrayBufferToBlob(arrayBuffer, 'application/pdf')
		const downloadLink = document.createElement('a')
		downloadLink.href = window.URL.createObjectURL(blob)
		downloadLink.download = `${name}.pdf`
		downloadLink.click()
	}

	static downloadArrayBuffer(arrayBuffer, name, type, extension) {
		const blob = this._arrayBufferToBlob(arrayBuffer, type)
		const downloadLink = document.createElement('a')
		downloadLink.href = window.URL.createObjectURL(blob)
		downloadLink.download = `${name}.${extension}`
		downloadLink.click()
	}
}
